import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromMapDataLayers from './map-data-layers.reducer';
import { MapDataLayersEffects } from './map-data-layers.effects';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(fromMapDataLayers.MAP_DATA_LAYERS_FEATURE_KEY, fromMapDataLayers.reducer),
        EffectsModule.forFeature([MapDataLayersEffects]),
    ],
})
export class MapDataLayersDataAccessModule {}
